<script>
    const consumptions = [0, 5, 10, 20];
    const flavors = ['sweet', 'floral', 'fruity', 'roasted', 'spices'];
    const roasts = ['light', 'medium', 'dark'];
    const grinds = [
        {
            name: 'whole bean', value: 'whole_bean'
        },
        {
            name: 'espresso grind', value: 'fine'
        },
        {
            name: 'pour over grind', value: 'medium'
        },
        {
            name: 'french press grind', value: 'course'
        }
    ];

    const questionnaire = {
        consumptions, grinds, flavors, roasts
    };

    const answers = {
        consumption_min: null,
        consumption_max: null,
        coffee_grind: [],
        coffee_flavor: [],
        coffee_roast: [],
        coffees: [],
        decaf: null,
    };

    import VueRecaptcha from 'vue-recaptcha';
    export default {

        components: { VueRecaptcha },

        props: {
            email: String
        },

        data: function () {
           return {
               consumptions,
               questionnaire,
               answers,
               emailExists: false,
               coffees: [],
               canSubmit: false
           }
        },

        methods: {
            switchAnswer: function (property, answer) {
                this.answers[property] = (this.answers[property] === answer) ? [] : answer;
            },
            switchGrind: function (answer) {
                this.answers.coffee_grind = (this.answers.coffee_grind === answer) ? [] : answer;
                this.findMatchingCoffee();
            },
            addAnswer: function (property, answer) {
                if (this.answers[property].includes(answer)) {
                    this.answers[property] = this.answers[property].filter(val => val !== answer);
                } else {
                    this.answers[property].push(answer);
                }

                if (property === 'coffee_flavor' || property === 'coffee_roast') {
                    this.findMatchingCoffee();
                }
            },
            selectConsumption(index) {
                if (this.isConsumptionSelected(index)) {
                    this.answers.consumption_min = this.answers.consumptionMax = null;
                    return;
                }
                this.answers.consumption_min = consumptions[index];
                this.answers.consumption_max = index < questionnaire.consumptions.length - 1 ?
                    questionnaire.consumptions[index + 1] : null;
            },
            addCoffee(coffeeId) {
              this.addAnswer('coffees', coffeeId)
            },
            isConsumptionSelected(index) {
                return consumptions[index] === this.answers.consumption_min;
            },
            toggleAnswer: function (property, answer) {
                this.answers[property] = (this.answers[property] === answer) ? null : answer;
            },
            findMatchingCoffee() {
                this.coffees = [];

                const params = {
                    grind: this.answers.coffee_grind,
                    flavors: this.answers.coffee_flavor,
                    roasts: this.answers.coffee_roast,
                    decaf: this.answers.decaf
                };

                this.$coffeesApi.get('questionnaire_matching_coffees', {params: params})
                    .then(res => {
                        this.coffees = res.data;
                        this.answers.coffees = [];
                    })
                    .catch(console.error)
            },
            // HACK: This is for a email validation and shouldn't be a part of the questionnaire component.
            validateEmail(event) {
                const email = event.target.value;

                // Don't need to check if email is incomplete
                const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!re.test(email)){
                    this.emailExists = false;
                    return;
                }

                this.$accountsApi.post('validate_email', { email: email })
                    .then(() => this.emailExists = false)
                    .catch(() => this.emailExists = true)
            },
            getAnswerInputName(key) {
                return `questionnaire[${key}]`;
            },
            onRecaptchaVerified(e) {
                this.canSubmit = true;
            }
        },
        mounted() {
            this.findMatchingCoffee();
        },
    }
</script>
